import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M22 12l-4-4v3H3v2h15v3z" />, 'TrendingFlat');
